import { Stack, styled } from "@mui/material";
import { COLORS } from "constants/layout";

export const StyledStack = styled(Stack)(({ theme }) => ({
  ".content-input": {
    "& .MuiInputBase-root": {
      flexDirection: "column",
    },
  },
  ".term-text": {
    a: {
      color: COLORS.green[700],
    },
  },
  ".email-input": {
    input: {
      paddingLeft: 0,
    },
  },

  [theme.breakpoints.down("md")]: {
    ".inquiry-btn": {
      maxWidth: 120,
    },
    ".inquiry-btn, .post-rfq-text p": {
      fontSize: 12,
    },
  },
}));
